import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import setActiveRoomClass, {
  resetActiveRoomClass,
} from '../../../../actions/setActiveRoomClassActions';
import { getAvailRoomClassOptions } from '../../../../utilities/content/roomClassFilter';
import ArrowDown from '../../../../assets/icons/arrow-down.svg';
import { onEnter } from '../../../../utilities/accessibility/onEnter';

class RoomClassFilterSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterExpanded: false,
    };

    this.handleFilterToggle = this.handleFilterToggle.bind(this);
  }

  handleFilterToggle() {
    this.setState({
      filterExpanded: !this.state.filterExpanded,
    });
  }

  render() {
    const {
      configData,
      groupAvailData,
      handleRoomClassSubmit,
      selectedRoomClassCodes,
      setSelectedRoomClassCodes,
      isFormBarExpanded,
    } = this.props;
    const { filterExpanded } = this.state;
    const hotelLabels = _.get(configData, 'hotel.labels[0]', []);
    let renderRoomClassFilter = null;

    const handleRoomClassSelect = (e) => {
      const isSelected = e.target.checked;
      const selectedRoomClassCode = parseInt(e.target.value, 10);

      if (isSelected) {
        setSelectedRoomClassCodes([
          ...selectedRoomClassCodes,
          selectedRoomClassCode,
        ]);
      } else {
        setSelectedRoomClassCodes(
          _.filter(
            selectedRoomClassCodes,
            (roomClassCode) => roomClassCode !== selectedRoomClassCode
          )
        );
      }
    };

    if (groupAvailData && groupAvailData.roomTypes) {
      const AvailRoomClassOptions = getAvailRoomClassOptions(
        _.get(groupAvailData, 'roomTypes')
      );

      renderRoomClassFilter = (
        <div className="bk-form-room__filter-select">
          <div
            aria-expanded={filterExpanded}
            onClick={this.handleFilterToggle}
            onKeyDown={event => onEnter(event, this.handleFilterToggle)}
            className="bk-form-room__filter-select-toggle"
            tabIndex={isFormBarExpanded ? 0 : -1}
          >
            {hotelLabels.roomTypes ? hotelLabels.roomTypes : 'Room Types'}
            <img
              alt={filterExpanded ? 'close' : 'open'}
              src={ArrowDown}
              className={filterExpanded ? 'rotate' : ''}
            />
          </div>
          <div
            className={`bk-form-room__filter-select-form ${
              filterExpanded ? 'active' : ''
            }`}
          >
            <div className="bk-form-room__filter-select-fields">
              {_.map(AvailRoomClassOptions, (option) => (
                <fieldset
                  key={option.value}
                  className="bk-form-room__filter-select-field"
                >
                  <input
                    type="checkbox"
                    name="roomClass"
                    id={option.value}
                    value={option.value}
                    onChange={handleRoomClassSelect}
                    checked={_.includes(selectedRoomClassCodes, option.value)}
                  />
                  <label htmlFor="roomClass">{option.label}</label>
                </fieldset>
              ))}
            </div>
            <div className="bk-form-room__filter-select-ctas">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ filterExpanded: false });
                }}
                className="btn btn-text-only"
              >
                {hotelLabels.cancel ? hotelLabels.cancel : 'Cancel'}
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ filterExpanded: false });
                  handleRoomClassSubmit(selectedRoomClassCodes);
                }}
                className="btn btn-primary"
              >
                {hotelLabels.apply ? hotelLabels.apply : 'Apply'}
              </button>
            </div>
          </div>
        </div>
      );
    }
    return renderRoomClassFilter;
  }
}

function mapStateToProps(state) {
  return {
    activeRoomClassData: state.activeRoomClassData,
  };
}

const mapDispatchToProps = (dispatch) => ({
  handleRoomClassSubmit(roomClassCodes) {
    if (roomClassCodes && roomClassCodes.length === 0) {
      return dispatch(resetActiveRoomClass());
    }
    return dispatch(setActiveRoomClass(roomClassCodes));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RoomClassFilterSelect);



// WEBPACK FOOTER //
// ./src/components/forms/filtersForm/elements/RoomClassFilterSelect.js